<template>
  <section class="mb-[-100svh] py-0 padding-x">
    <div
      id="hero"
      class="top-0 sticky flex items-end pb-[clamp(2.25rem,2.1786rem_+_0.3571vi,2.5rem)] w-full min-h-svh"
    >
      <div class="relative flex flex-col items-center w-full">
        <div class="items-end w-full overflow-clip">
          <div class="flex items-start gap-10 w-full">
            <MyName />
            <Star id="star" class="translate-x-full hide-on-mobile" />
          </div>
        </div>

        <div class="grid grid-cols-12 w-full lg:column-gap spacing-t">
          <div
            class="flex flex-col items-start gap-14 col-span-full sm:col-span-4"
          >
            <div class="overflow-hidden">
              <svg
                id="down-arrow"
                stroke="currentColor"
                fill="none"
                stroke-width="1.25"
                viewBox="6 6 12 12"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="m-0 p-0 size-4 md:size-6 -translate-x-full hide-on-mobile"
                color="#8C8C73"
                style="color: #8c8c73"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="7" y1="7" x2="17" y2="17"></line>
                <polyline points="17 7 17 17 7 17"></polyline>
              </svg>
            </div>

            <p class="sr-only">
              A freelance full-stack web developer, cutting-edge technologies to
              deliver comprehensive solutions for your business.
            </p>
            <p
              v-html="whoAmI"
              id="whoAmI"
              class="w-full max-w-[30ch] sm:max-w-[37ch] overflow-clip font-medium lg:text-start text-balance leading-snug who-am-i heading-5"
            ></p>

            <div class="relative overflow-hidden sm:scale-150 origin-left">
              <div id="contact-btn" class="flex -translate-y-full">
                <Button
                  :data-cal-namespace="dataCalNamespace"
                  :data-cal-link="dataCalLink"
                  :data-cal-config="dataCalConfig"
                  class="contact"
                  label="Get in touch"
                />
              </div>
            </div>
          </div>

          <div
            id="profile-container"
            class="relative md:flex flex-col col-span-4 mt-10 sm:mt-0 rounded-lg max-w-lg h-[20vh] sm:h-full md:h-[50vh] select-none"
          >
            <div class="z-2 absolute inset-0 bg-flax-smoke-50 overlay"></div>
            <img
              id="profile-img"
              :src="profile"
              alt=""
              class="brightness-110 grayscale rounded-lg size-full object-cover object-top scale-90"
            />
          </div>

          <!-- content-end justify-self-end  -->
          <div
            class="relative col-span-8 sm:col-span-4 size-full overflow-clip text-end"
          >
            <div
              id="available-for-work"
              class="right-0 bottom-0 absolute flex flex-col items-end translate-y-full"
            >
              <p
                class="block font-medium 3xl:text-base uppercase leading-snug -tracking-tight"
              >
                Available for freelance work
              </p>
              <!-- <h3
                class="block font-fancy font-bold leading-none -tracking-tight 3xl:heading-1 heading-1-alt"
              >
                {{ AvailableForWorkDate }}
              </h3> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-svh"></div>
  </section>
</template>

<script setup lang="ts">
  import { onBeforeMount, ref } from 'vue';
  import { MyName, Star } from '../design';
  import { Button } from '@/components/common';
  import { profile } from '@/assets/images';
  import { getAvailableForWorkDate, textSplitterIntoChar } from '@/functions';
  import { dataCalConfig, dataCalLink, dataCalNamespace } from '@/data';

  const whoAmI = ref(
    'A freelance full-stack web developer, cutting-edge technologies to deliver comprehensive solutions for your business.',
  );
  const AvailableForWorkDate = ref('');

  onBeforeMount(() => {
    whoAmI.value = textSplitterIntoChar(whoAmI.value);
    AvailableForWorkDate.value = getAvailableForWorkDate();
  });
</script>
